var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rp-roles"},[(!_vm.activeRoleId && !_vm.createNewRole)?_c('rp-roles-wellcome'):_c('rp-roles-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }